import { useMutation } from '@tanstack/react-query';
import { logoutAllSessions, logoutSession } from '@/lib/api/settings/api';
import { queryClient } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';
import { stanNotify } from '@/lib/stanNotify';

/**
 * Mutation hook for logging out a specific session
 */
export function useLogoutSession() {
    return useMutation({
        mutationFn: (sessionId: string) => logoutSession(sessionId),
        onSuccess: () => {
            // Refresh the sessions list after logout
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LOGIN_SESSIONS] });
            stanNotify({
                type: 'success',
                title: 'Success!',
                text: 'Session logged out successfully.',
            });
        },
        onError: () => {
            stanNotify({
                type: 'error',
                title: 'Error',
                text: 'Failed to logout session. Please try again later.',
            });
        },
    });
}

/**
 * Mutation hook for logging out all other sessions (except current)
 */
export function useLogoutAllSessions() {
    return useMutation({
        mutationFn: () => logoutAllSessions(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LOGIN_SESSIONS] });
        },
        onError: () => {
            stanNotify({
                type: 'error',
                title: 'Error',
                text: 'An error occurred while logging out sessions.',
            });
        },
    });
}
